import React, { useEffect } from "react";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import {
  DialogContent,
  DialogContentText,
  TableCell,
  TableRow,
} from "@mui/material";
import { useSelector } from "react-redux";
import closeIcon from "../../../../assets/closeModel.png";
import { useDispatch } from "react-redux";
import { getLeadEstimateAction } from "../../../../store/reducers/leadSlice";
import Popup from "../../../../components/common/model/Popup";
import CustomButton from "../../../../components/common/button/CustomButton";
import useStyles from "../../../../components/common/model/styles";
const QuoteList = ({ open, onHide, title, onSelect,setSelectedQuote }: any) => {
  const { leadDetails, selectedLeadQuote } = useSelector(
    (state: any) => state.lead
  );
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getLeadEstimateAction({
        generatedId: leadDetails?.lead?.generated_id,
        screenType: "quotation",
      })
    );
  }, []);
  const tableHeadings: TableHeading[] = [
    { label: "Quote Ref", align: "center" as const },
    { label: "Service", align: "center" as const },
    { label: "Accepted Date", align: "center" as const },
    { label: "Total (£)", align: "center" as const },
  ];

  return (
    <>
      <Popup
        open={open}
        title={title || ""}
        onHide={onHide}
        fullWidth={true}
        maxWidth={"sm"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={onHide}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton variant="outlined" title="Cancel" onClick={onHide} />
            {/* <CustomButton title="Continue" onClick={submitHandler} /> */}
          </>
        }
      >
        <DialogContent sx={{ padding: "0px" }}>
          <DialogContentText>
            <TableDesign
              tableHeadings={tableHeadings}
              tableHeadColor={"#fff"}
              cellColor={"#000"}
              pagination={null}
              stickyHeader={true}
              isLoader={false}
              filterOption={() => {}}
              setFilterOption={() => {}}
            >
              {selectedLeadQuote?.quotes.length > 0 ? (
                selectedLeadQuote?.quotes
                  ?.filter((val: any) => val?.accepted_status?.toUpperCase() === "ACCEPTED")
                  ?.map((val: any, idx: number) => {
                    return (
                      <React.Fragment key={idx}>
                        <TableRow
                          // key={val?.client_id}
                          sx={{
                            fontWeight: 600,
                            // border: "1px solid #d1cfcf",
                            backgroundColor:
                              idx % 2 === 0 ? "#F9F9F9" : "#FFFFFF",
                            "&:hover": {
                              backgroundColor: "#E5F4F1",
                              cursor: "pointer",
                            },
                          }}
                          onClick={() => { onSelect(); setSelectedQuote(val); }}
                        >
                          <TableCell
                            align="center"
                            style={{ padding: "4px 0px", cursor: "pointer" }}
                            
                          >
                            {idx + 1}-
                            {val.created_at
                              ? new Date(val.created_at).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit",
                                  }
                                )
                              : "N/A"}
                            
                          </TableCell>
                          <TableCell align="center">
                            {val?.services?.map((service: any) => service.typeName).join(", ")}
                          </TableCell>
                          <TableCell align="center">
                            {val?.updated_at
                              ? new Date(val?.updated_at).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit",
                                  }
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            £ {val?.quoteTotal ? Number(val?.quoteTotal)?.toFixed(2) : "0.00"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeadings?.length}>
                    <span style={{ position: "absolute" }}>
                      Data Not Found!
                    </span>
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};

export default QuoteList;
